import React from 'react'

function Authority() {
  return (
    <section className="bg-[#FCFAF5] py-20 md:py-28">
      <div className="max-w-[1200px] mx-auto px-6 md:px-10">
        <div className="grid md:grid-cols-2 gap-14 items-center mb-16">
          <div className="animate-fade-up space-y-5 order-2 md:order-1">
            <p className="text-[#D9891B] font-semibold uppercase tracking-wide text-sm">Criado por quem entende de cozinha</p>
            <h2 className="font-display text-[#49352B] text-3xl md:text-5xl font-bold leading-tight">
              Uma vida dedicada à gastronomia saudável
            </h2>
            <p className="text-[#49352B]/80 text-lg leading-relaxed font-medium">
              Olá, eu sou Mariana Oliveira, criadora do Método Massa Perfeita™.
            </p>
            <p className="text-[#49352B]/80 text-lg leading-relaxed">
              Eu simplesmente me recusei a aceitar que comida saudável precisava ter gosto de sacrifício.
              Pães que desmanchavam, massas pesadas, receitas que prometiam sabor de padaria e entregavam
              só frustração — até eu decidir mudar isso.
            </p>
            <p className="text-[#49352B]/80 text-lg leading-relaxed">
              Foram anos testando farinhas, proporções e técnicas artesanais até nascer o Método Massa
              Perfeita™ — o equilíbrio exato entre saúde e sabor.
            </p>
            <p className="text-[#49352B]/80 text-lg leading-relaxed">
              Hoje, o FORNO ESSENCIAL® já devolveu a milhares de famílias o prazer de sentir o cheirinho
              de pão quentinho saindo do forno — sem abrir mão da saúde.
            </p>
          </div>
          <div className="animate-fade-up order-1 md:order-2 rounded-[20px] overflow-hidden shadow-xl">
            <img
              src="https://static.lumi.new/34/34a34d6302fe00cc902fa07cf453ce75.png"
              alt="Especialista culinária"
              className="w-full h-[420px] md:h-[480px] object-cover"
            />
          </div>
        </div>

        <div className="animate-fade-up text-center">
          <p className="text-[#49352B]/50 text-sm uppercase tracking-widest font-semibold mb-8">
            Destaque em publicações sobre gastronomia saudável
          </p>
          <div className="flex flex-wrap items-center justify-center gap-x-12 gap-y-8 opacity-70">
            <img src="https://static.lumi.new/ef/ef3fa6b51059657b78a169f08529dedd.png" alt="Revista de gastronomia" className="h-10 md:h-12 object-contain grayscale" />
            <img src="https://static.lumi.new/29/29897c85d6e7ccaa9a383edad9823d5b.png" alt="Revista de vida saudável" className="h-10 md:h-12 object-contain grayscale" />
            <img src="https://static.lumi.new/b1/b1747c6d466c29e5580cdfc94233e096.png" alt="Revista culinária" className="h-10 md:h-12 object-contain grayscale" />
          </div>
        </div>
      </div>
    </section>
  )
}

export default Authority
